/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Boundary_BodyInputs */

const en_us2_errors_boundary_body = /** @type {(inputs: Errors_Boundary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This screen hit an error and stopped. Whatever you already saved is still saved. Reloading usually fixes it.`)
};

const pt_br2_errors_boundary_body = /** @type {(inputs: Errors_Boundary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta tela encontrou um erro e parou. O que você já salvou continua salvo. Recarregar costuma resolver.`)
};

const es_419_errors_boundary_body = /** @type {(inputs: Errors_Boundary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta pantalla encontró un error y se detuvo. Lo que ya guardaste sigue guardado. Recargar suele resolverlo.`)
};

const pt_pt2_errors_boundary_body = /** @type {(inputs: Errors_Boundary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ecrã encontrou um erro e parou. O que já guardaste continua guardado. Recarregar costuma resolver.`)
};

const fr_fr2_errors_boundary_body = /** @type {(inputs: Errors_Boundary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet écran a rencontré une erreur et s'est arrêté. Ce que tu as déjà enregistré l'est toujours. Recharger règle généralement le problème.`)
};

const de_de2_errors_boundary_body = /** @type {(inputs: Errors_Boundary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf diesem Bildschirm ist ein Fehler aufgetreten. Alles, was du schon gespeichert hast, bleibt gespeichert. Neu laden hilft meistens.`)
};

const it_it2_errors_boundary_body = /** @type {(inputs: Errors_Boundary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa schermata ha incontrato un errore e si è fermata. Quello che hai già salvato resta salvato. Di solito basta ricaricare.`)
};

/**
* | output |
* | --- |
* | "This screen hit an error and stopped. Whatever you already saved is still saved. Reloading usually fixes it." |
*
* @param {Errors_Boundary_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const errors_boundary_body = /** @type {((inputs?: Errors_Boundary_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Boundary_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_errors_boundary_body(inputs)
	if (locale === "es-419") return es_419_errors_boundary_body(inputs)
	if (locale === "pt-PT") return pt_pt2_errors_boundary_body(inputs)
	if (locale === "fr-FR") return fr_fr2_errors_boundary_body(inputs)
	if (locale === "de-DE") return de_de2_errors_boundary_body(inputs)
	if (locale === "it-IT") return it_it2_errors_boundary_body(inputs)
	return en_us2_errors_boundary_body(inputs)
});
export { errors_boundary_body as "errors-boundary.body" }